import { ActionContext } from "vuex";

export default {
  namespaced: true,
  state: {
    filter: {
      status: undefined,
      deviceType: undefined,
      signedBy: undefined,
      csrSubject: undefined,
      slotId: undefined,
      simId: undefined,
      iccid: undefined,
      createdAtFrom: undefined,
      createdAtTo: undefined,
    },
    items: [] as any[],
    updated_index: -1,
  },
  getters: {
    getItems: (state: any) => state.items || [],
    getUpdatedIndex: (state: any) => state.updated_index,
  },
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
    SET_ITEMS: (state: any, payload: any) => (state.items = payload),
    SET_UPDATED_INDEX: (state: any, payload: any) => (state.updated_index = payload),
  },
  actions: {
    applyFilter: ({ commit }: ActionContext<any, any>, payload: any) => commit("APPLY_FILTER", payload),
    refreshItems: ({ state, commit }: ActionContext<any, any>) => {
      commit("SET_ITEMS", [...state.items]);
    },
    clearUpdatedIndex: ({ commit }: ActionContext<any, any>) => {
      commit("SET_UPDATED_INDEX", -1);
    },
  },
};
